import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';

interface Deps { membershipRepository: IMembershipRepository; }
export interface UpdateMemberMetadataInput { membershipId: string; metadatas: Record<string, any>; }
export function createUpdateMemberMetadataUseCase({ membershipRepository }: Deps) {
  return async function updateMemberMetadata(input: UpdateMemberMetadataInput): Promise<void> {
    return membershipRepository.updateMemberMetadata(input.membershipId, input.metadatas);
  };
}
